module.exports = __webpack_public_path__ + "img/hour-glass.121e76b3.svg";